import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const PageDetailsModal = ({
  selectedPage,
  setSelectedPage,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedPage(null);
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Custom Page Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">
                Page Content
              </span>
              <div
                className="d-block fs-5 fw-medium overflow-auto"
                dangerouslySetInnerHTML={{ __html: selectedPage?.content }}
              />
            </div>
          </Col>
          {Object.entries({
            "Page Heading": selectedPage?.heading || "",
            Section: selectedPage?.section || "",
            Status: selectedPage?.status ? "Active" : "In-Active",
            "Created At": selectedPage?.createdAt
              ? format(selectedPage?.createdAt, "PP")
              : "",
            "Updated At": selectedPage?.updatedAt
              ? format(selectedPage?.updatedAt, "PP")
              : "",
            "Deleted At": selectedPage?.deletedAt
              ? format(selectedPage?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PageDetailsModal;
